import { combineReducers } from 'redux';
import councils, * as councilSelectors from './councils';
import ui, * as uiSelectors from './ui';

const rootReducer = combineReducers({
  councils: councils,
  ui: ui,
});

export default rootReducer;

export const getCouncils = state =>
  councilSelectors.getCouncilsData(state.councils);

export const getQldCouncilsGeo = state =>
  councilSelectors.getQldCouncilsGeo(state.councils);

export const getIsFetchingCouncils = state =>
  uiSelectors.getIsFetchingCouncils(state.ui);

export const getIsMobile = state => uiSelectors.getIsMobile(state.ui);

export const getActiveCouncil = state => {
  const activeCouncilId = uiSelectors.getActiveCouncil(state.ui);
  return activeCouncilId
    ? councilSelectors
        .getCouncilsData(state.councils)
        .find(council => council.id === activeCouncilId)
    : null;
};

export const getComparedCouncil = state => {
  const comparisonCouncilId = uiSelectors.getComparedCouncil(state.ui);
  return comparisonCouncilId
    ? councilSelectors
        .getCouncilsData(state.councils)
        .find(council => council.id === comparisonCouncilId)
    : null;
};

export const getActivePage = state => uiSelectors.getActivePage(state.ui);



// WEBPACK FOOTER //
// ./src/reducers/index.js